import { ChangeDetectionStrategy, Component, ContentChild, TemplateRef, forwardRef, input } from "@angular/core";
import { FormWrapper } from "../wrapper.interface";
import { ToggleButtonModule } from "primeng/togglebutton";
import { CommonModule } from "@angular/common";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { V_FORM_CONTROL_TOKEN, WRAPPER_TOKEN } from "../wrapper.tokens";
import { ToggleButtonConfig } from "./toggleButton.config";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector:    'v-toggleButton',
    templateUrl: './toggleButton.component.haml',
    providers:   [
        { provide: V_FORM_CONTROL_TOKEN, useExisting: forwardRef(() => VToggleButtonComponent) },
        { provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VToggleButtonComponent) },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => VToggleButtonComponent), multi: true }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:         [CommonModule, ToggleButtonModule, ReactiveFormsModule, TranslateModule]
})
export class VToggleButtonComponent extends FormWrapper<ToggleButtonConfig, boolean>{
    protected _baseConfig: ToggleButtonConfig = ToggleButtonConfig.baseTheme.Default;

    checkedLabelInput = input<string>(undefined, {alias: "checkedLabel"});
    uncheckedLabelInput = input<string>(undefined, {alias: "uncheckedLabel"});

    public get checkedLabel(): string {
        return this.checkedLabelInput() ?? this.config().checkedLabel ?? "Ja";
    }

    public get uncheckedLabel(): string {
        return this.uncheckedLabelInput() ?? this.config().uncheckedLabel ?? "Nein";
    }

    @ContentChild('checked', { static: false}) public checkedTemplateRef: TemplateRef<unknown>;
    @ContentChild('unchecked', { static: false}) public uncheckedTemplateRef: TemplateRef<unknown>;

}